import { IJxtOffCanvasFooter } from './types';

export const JxtOffCanvasFooter = ({ children }: IJxtOffCanvasFooter) => (
  <footer className="border-t border-neutral-20 px-6 pt-3 pb-8">{children}</footer>
);
